<script>
  export let response;

  function cleanInventor(inventor) {
    return inventor.map(function(data){
      return data.replace(';',',<br/>');
    });
  }
  function displayInventor(inventor) {
    return cleanInventor(inventor).join(';<br/><br/>');
  }
</script>
<div class="quote">
  <h1>Quotation</h1>
  <div class="content">
    <div class="content-row"><p class="label">PCT: </p>{response.pct}</div>
    <div class="content-row"><p class="label">Title: </p>{response.title}</div>
    <div class="content-row"><p class="label">Inventors: </p>{@html displayInventor(response.inventors)}</div>
    <div class="subtotal">
      <div class="row">
        <span class="leftTotal">Initial Filing Fee:</span>
        <span class="rightTotal">$590</span>
      </div>
      <div class="row">
        <span class="leftTotal">Information Disclosure Statement:</span>
        <span class="rightTotal">$200</span>
      </div>
      <div class="row">
        <span class="leftTotal">USPTO fee*:</span>
        <span class="rightTotal">$830</span>
      </div>
      <div class="row total">
        <span class="leftTotal">Total:</span>
        <span class="rightTotal">$1,620</span>
      </div>
    </div>
  </div>
  <div class="leftAlign">
  <span>(Disclaimers) I acknowledge that there may be additional costs following the initial filing and that the above estimate does <u>not</u> include any of the following:</span>
    <ul>
      <li>Excess claims (any independent claims in excess of 3 or any total claims in excess of 20)</li>
      <li>Multiple dependent claims</li>
      <li>Preliminary Amendment</li>
      <li>Late filing of signed inventor declaration(s)</li>
    </ul>
  </div>
  <p class="small_text">*For small entity applicants (e.g., individual inventors, a small business with fewer than 500 employees, or nonprofit organization regardless of size).</p>
</div>
<style>
  .quote {
    border: 1px solid black;
    margin: 1rem;
  }

  li {
    margin: auto;
  }
  .content {
    font-size: 16px;
    line-height: 20px;
    width: 95%;
    margin: 3rem auto;
  }
  .content-row {
    padding: .5rem;
  }
  .subtotal {
    padding: 0rem;
    width: 20%;
    margin: 2rem auto;
  }
  .row {
    display:flex;
    justify-content: space-between;
  }
  .total {
    padding: 0rem;
    border-top: 1px solid black;
    font-weight: bold;
    border-bottom: 3px double black;
  }
  .small_text {
    font-size: 16px;
  }
  .leftTotal {

  }
  .rightTotal {

  }
  .leftAlign {
    width: 90%;
    text-align: left;
    margin: auto;
  }
  .label {
    font-weight: bold;
    margin: 0;
  }
</style>
